import React, { useContext } from "react";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import AppContext from "../../store/app-context";

import styles from "./impression.module.css";

const Impression = () => {
  const appCtx = useContext(AppContext);

  return (
    <>
      <div className={styles.actions}>
        <button
          className={styles.button}
          onClick={() => appCtx.handleNextStep(2, "satisfy")}
        >
          Survey Kepuasan
        </button>
        <button
          className={styles.button}
          onClick={() => appCtx.handleNextStep(2, "complain")}
        >
          Keluhan
        </button>
        <button
          className={styles.button}
          onClick={() => appCtx.handleNextStep(3, "ask")}
        >
          Pertanyaan
        </button>
      </div>
      {/* <div
        className={styles.question}
        onClick={() => appCtx.handleNextStep(3, "ask")}
      >
        <HelpOutlineIcon />
        <span>Pertanyaan</span>
      </div> */}
    </>
  );
};

export default Impression;
